import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import AppHeader from "@/components/AppHeader";
import MobileNav from "@/components/MobileNav";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Send, AlertTriangle, ArrowLeft } from "lucide-react";

const SEV = {
  sent:   { dot: "bg-emerald-400", text: "text-emerald-300", label: "Sent" },
  failed: { dot: "bg-red-400",     text: "text-red-300",     label: "Failed" },
};

function fmtDate(iso) {
  try { return new Date(iso).toLocaleString(); } catch { return iso; }
}

export default function NotificationsHistoryPage() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const nav = useNavigate();
  useEffect(() => {
    api.get("/notifications/history").then(r => setItems(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, []);
  return (
    <div className="min-h-screen bg-[#0A0D14] pb-24 md:pb-8">
      <AppHeader />
      <MobileNav />
      <main className="max-w-4xl mx-auto px-4 sm:px-6 py-6">
        <button onClick={() => nav(-1)} className="text-slate-400 hover:text-white text-xs uppercase tracking-widest flex items-center gap-1 mb-3">
          <ArrowLeft className="h-3 w-3" /> Back
        </button>
        <div className="flex items-end justify-between mb-4">
          <div>
            <div className="text-xs uppercase tracking-widest text-emerald-400">Discord</div>
            <h1 className="text-3xl sm:text-4xl font-black uppercase tracking-tight text-white" style={{ fontFamily: "Barlow Condensed, sans-serif" }}>
              Notification History
            </h1>
          </div>
        </div>

        {loading ? (
          <div className="text-slate-500 text-sm">Loading...</div>
        ) : items.length === 0 ? (
          <div className="rounded-xl border border-dashed border-white/10 p-10 text-center bg-[#121824]/60">
            <div className="text-white font-bold uppercase tracking-wide mb-1" style={{ fontFamily: "Barlow Condensed, sans-serif" }}>
              No notifications yet
            </div>
            <p className="text-slate-400 text-sm">Once your slips move, we'll log every ping we send to Discord here.</p>
          </div>
        ) : (
          <ul className="space-y-2" data-testid="notifications-history-list">
            {items.map(n => {
              const s = SEV[n.status] || SEV.sent;
              return (
                <li
                  key={n.log_id}
                  data-testid={`notif-log-${n.log_id}`}
                  className="rounded-lg bg-[#121824] border border-white/10 p-3 flex items-start gap-3 cursor-pointer hover:border-emerald-500/40 transition-colors"
                  onClick={() => n.slip_id && nav(`/slip/${n.slip_id}`)}
                >
                  <span className={`mt-1 h-2 w-2 rounded-full flex-shrink-0 ${s.dot}`} />
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2">
                      <span className="text-[10px] uppercase tracking-widest text-slate-500">{n.channel}</span>
                      <span className={`text-[10px] uppercase tracking-widest font-bold ${s.text}`}>{s.label}</span>
                      <span className="text-[10px] uppercase tracking-widest text-slate-500">· {n.event_type}</span>
                    </div>
                    <div className="text-sm text-white font-semibold mt-1">{n.message}</div>
                    {n.status === "failed" && n.error && (
                      <div className="mt-1 text-xs text-red-300 flex items-center gap-1"><AlertTriangle className="h-3 w-3" /> {n.error}</div>
                    )}
                    <div className="text-[10px] uppercase tracking-widest text-slate-500 mt-1">{fmtDate(n.created_at)}</div>
                  </div>
                  <Send className="h-4 w-4 text-slate-500 flex-shrink-0 mt-1" />
                </li>
              );
            })}
          </ul>
        )}
      </main>
    </div>
  );
}
